module.exports = __webpack_public_path__ + "static/media/V7.28828194.mp4";